import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { BaseModel } from "../Generics/BaseModel"
import { SelectionOptionEntity } from "./SelectionOptionEntity"

export class SelectionEntity extends BaseModel {
  id: number

  name: string

  description: string

  status: EEnableStatusType

  options: SelectionOptionEntity[]

  allowMultiple: boolean

  isRequired: boolean

  requiredOptionsCount: number

  freeOptionsLimit: number

  hasMaximumSelectionsLimit: boolean

  maximumSelectionsLimit: number

  constructor(data: Partial<SelectionEntity> = {}) {
    super()

    this.id = data.id ?? -1

    this.name = data.name ?? ""

    this.description = data.description ?? ""

    this.status = data.status ?? EEnableStatusType.Active

    this.options = (data.options ?? []).map((e) => new SelectionOptionEntity(e))

    this.allowMultiple = data.allowMultiple ?? false

    this.isRequired = data.isRequired ?? false

    this.requiredOptionsCount = data.requiredOptionsCount ?? 1

    this.freeOptionsLimit = data.freeOptionsLimit ?? 0

    this.hasMaximumSelectionsLimit = data.hasMaximumSelectionsLimit ?? false

    this.maximumSelectionsLimit = data.maximumSelectionsLimit ?? 0
  }
}
